export var CompareEmptyCardType;
(function (CompareEmptyCardType) {
    CompareEmptyCardType["STICKY"] = "sticky";
    CompareEmptyCardType["DEFAULT"] = "default";
})(CompareEmptyCardType || (CompareEmptyCardType = {}));
export const MAX_COMPARE_PRODUCTS = 4;
export const MIN_COMPARE_PRODUCTS = 2;
